import { handleRequest } from "../utilities/requestHandler";

export const getMachines = () =>
    handleRequest("get","/machines");

export const uploadMachineAssets = (formData) =>
    handleRequest("post", "/machines/upload-assets", formData, { 'Content-Type': 'multipart/form-data' });

export const updateMachine = (machineId, machineData) =>
    handleRequest("put", `/machines/${machineId}`, machineData);

export const createMachine = (machineData) =>
    handleRequest("post", "/machines/create", machineData);

export const deleteMachines = (ids) =>
    handleRequest("post", "/machines/delete", { ids });